export const desktopNavItems = [
  {
    icon: 'assets/img/menu-dashboard-white.svg',
    activeIcon: 'assets/img/menu-dashboard-green.svg',
    label: 'Overview',
    target: '/overview',
    showAgentIndicator: true,
  },
  {
    icon: 'assets/img/menu-schedule-white.svg',
    activeIcon: 'assets/img/menu-schedule-green.svg',
    label: 'Schedule',
    target: '/schedule',
    showAgentIndicator: true,
    key: 'schedule_agent'
  },
  {
    icon: 'assets/svg/chatbubbles-outline.svg',
    activeIcon: 'assets/img/menu-messages-green.svg',
    label: 'Messages',
    target: '/messages',
    showAgentIndicator: true,
    key: 'messages_agent'
  },
  {
    icon: 'assets/svg/checkbox-outline.svg',
    activeIcon: 'assets/img/menu-to-dos-green.svg',
    label: 'Checklists',
    target: '/checklists',
    showAgentIndicator: true,
    key: 'job_quality_agent'
  },
  {
    icon: 'assets/svg/people-outline.svg',
    activeIcon: 'assets/img/menu-my-pros-green.svg',
    label: 'Contacts',
    target: '/contacts',
    showAgentIndicator: true,
    key: 'my_pros_agent'
  }
];

export const prosItem = {
  icon: 'assets/svg/people-outline.svg',
  activeIcon: 'assets/img/menu-my-pros-green.svg',
  label: 'Pros',
  target: '/my-pros',
  showAgentIndicator: true,
  key: 'my_pros_agent'
};

export const integrationSectionItems = [
  {
    activeIcon: 'assets/img/integration-images/all-integrations-green.svg',
    icon: 'assets/img/integration-images/all-integrations-white.svg',
    label: 'All Integrations',
    target: 'integration/all'
  },
  {
    activeIcon: 'assets/img/integration-images/property-management-green.svg',
    icon: 'assets/img/integration-images/property-management-white.svg',
    label: 'Property Management',
    target: 'integration/property-management'
  },
  {
    activeIcon: 'assets/img/integration-images/booking-channel-green.svg',
    icon: 'assets/img/integration-images/booking-channel-white.svg',
    label: 'Booking Channel',
    target: 'integration/booking-channel'
  },
  {
    activeIcon: 'assets/img/integration-images/notifications-green.svg',
    icon: 'assets/img/integration-images/notifications-white.svg',
    label: 'Notifications',
    target: 'integration/notifications'
  },
  {
    activeIcon: 'assets/img/integration-images/accounting-integration-green.svg',
    icon: 'assets/img/integration-images/accounting-integration-white.svg',
    label: 'Accounting',
    target: 'integration/accounting'
  },
  {
    activeIcon: 'assets/img/integration-images/lock-integration-green.svg',
    icon: 'assets/img/integration-images/lock-integration-white.svg',
    label: 'Locks',
    target: 'integration/locks'
  },
  {
    activeIcon: 'assets/img/integration-images/thermostat-green.svg',
    icon: 'assets/img/integration-images/thermostat-white.svg',
    label: 'Thermostats',
    target: 'integration/thermostats'
  }
]

export const automationsSectionItems = [
  {
    icon: 'assets/img/robot-white.svg',
    activeIcon: 'assets/img/robot-green.svg',
    label: 'Automations',
    target: '/automations/summary'
  },
  {
    icon: 'assets/img/workflow-white.svg',
    activeIcon: 'assets/img/workflow-green.svg',
    label: 'Workflows',
    target: '/automations/workflows'
  },
  {
    icon: 'assets/img/history-outline-white.svg',
    activeIcon: 'assets/img/history-outline-green.svg',
    label: 'Workflow History',
    target: '/automations/workflow-history'
  },
  {
    icon: 'assets/img/briefcase-white.svg',
    activeIcon: 'assets/img/briefcase-green.svg',
    label: 'Auto-Schedule',
    target: 'automations/automatic-booking',
  },
  {
    activeIcon: 'assets/img/integration-images/notifications-green.svg',
    icon: 'assets/img/integration-images/notifications-white.svg',
    label: 'Notifications',
    target: 'automations/account-notifications'
  }
];

export const automationsItem = {
  icon: 'assets/img/menu-automations-white.svg',
  activeIcon: 'assets/img/menu-automations-green.svg',
  label: 'Old',
  target: '/automations/summary',
  showAgentIndicator: true,
};

export const tasksItem = {
  icon: 'assets/svg/build-outline.svg',
  activeIcon: 'assets/img/alert-white.svg',
  label: 'Maintenance',
  target: '/maintenance',
  showAgentIndicator: true,
  key: 'issues_agent'
};

export const billsItem = {
  icon: 'assets/img/menu-bills-white.svg',
  activeIcon: 'assets/img/menu-bills-green.svg',
  label: 'Bills',
  target: '/bills',
  showAgentIndicator: true,
  key: 'bills_agent'
};

export const financeItem = {
  icon: 'assets/img/integration-images/accounting-integration-white.svg',
  activeIcon: 'assets/img/integration-images/accounting-integration-green.svg',
  label: 'Finance',
  target: '/finance',
  showAgentIndicator: false,
};

export const inventoryItem = {
  icon: 'assets/svg/cart-outline.svg',
  activeIcon: 'assets/img/menu-inventory-green.svg',
  label: 'Restocking',
  target: '/restocking',
  showAgentIndicator: true,
  key: 'inventory_agent'
};

export const propertiesItem = {
  icon: 'assets/img/menu-properties-outline-white.svg',
  activeIcon: 'assets/img/menu-properties-outline-green.svg',
  label: 'Properties',
  target: '/properties',
  showAgentIndicator: false
};

export const marketingItem = {
  icon: 'assets/img/menu-automations-white.svg',
  activeIcon: 'assets/img/menu-automations-green.svg',
  label: 'Marketing',
  target: '/revenue',
  showAgentIndicator: true,
  key: 'marketing_agent'
};

export const upsellItem = {
  icon: 'assets/img/upsell-header-white.svg',
  activeIcon: 'assets/img/upsell-header-green.svg',
  label: 'Upsell',
  target: '/upsell',
  showAgentIndicator: true,
  key: 'upsells_agent'
};

export const upsellsItem = {
  icon: 'assets/img/enable-upsells-white.svg',
  activeIcon: 'assets/img/enable-upsells-white.svg',
  label: 'Upsells',
  target: '/upsells',
  showAgentIndicator: true,
};

export const agentItem = {
  icon: 'assets/svg/robot-outline.svg',
  activeIcon: 'assets/img/menu-automations-green.svg',
  label: 'Agents',
  target: '/agent',
  showAgentIndicator: false
};

export const moreItem = {
  icon: 'assets/img/menu-more-white.svg',
  activeIcon: 'assets/img/menu-more-green.svg',
  label: 'More',
  target: '/more',
  showAgentIndicator: false
};

export const moreAutomaticBookingItem = {
  icon: 'assets/img/briefcase-white.svg',
  activeIcon: 'assets/img/briefcase-green.svg',
  label: 'Auto-Schedule',
  target: '/automatic-booking',
};

export const operationsSection = {
  label: 'Operations',
  target: '/properties',
};

// First sub-item in the Operations section: the Properties dashboard.
export const operationsOverviewItem = {
  label: 'Properties',
  target: '/properties',
  icon: 'assets/svg/grid-outline.svg',
  isOverview: true,
  showAgentIndicator: false,
};

// Standalone sibling pages of the Properties dashboard — each gets its own
// route with a single desktop header (no tabs).
export const operationsAccessItem = {
  label: 'Access',
  target: '/access',
  icon: 'assets/svg/key-outline.svg',
  showAgentIndicator: false,
};

export const operationsUpgradesItem = {
  label: 'Upgrades',
  target: '/upgrades',
  icon: 'assets/svg/rocket-outline.svg',
  showAgentIndicator: false,
};

export const operationsAssetsItem = {
  label: 'Assets',
  target: '/assets',
  icon: 'assets/svg/cube-outline.svg',
  showAgentIndicator: false,
};

// Compliance siblings — each opens a dedicated page (no shared tab nav).
export const noiseMonitoringItem = {
  label: 'Noise Monitoring',
  target: '/noise-monitoring',
  icon: 'assets/svg/volume-high-outline.svg',
  showAgentIndicator: false,
};

export const insuranceItem = {
  label: 'Insurance',
  target: '/insurance',
  icon: 'assets/svg/umbrella-outline.svg',
  showAgentIndicator: false,
};

export const financeSection = {
  label: 'Finance',
  // The Finance section header opens Overview (the P&L charts page), not the
  // Finance tab pages. The sub-items below link to the individual tabs.
  target: '/overview',
};

export const financeSectionItems = [
  { label: 'Overview', tab: 'overview', isOverview: true, route: '/overview', target: '/overview', icon: 'assets/svg/grid-outline.svg' },
  { label: 'Bills', tab: 'bills', target: '/finance?tab=bills', icon: 'assets/svg/receipt-outline.svg' },
  { label: 'Deposits', tab: 'deposits', target: '/finance?tab=deposits', icon: 'assets/svg/wallet-outline.svg' },
  { label: 'Rent Collection', tab: 'rent-collection', isOverview: true, route: '/rent-collection', target: '/rent-collection', icon: 'assets/svg/card-outline.svg' },
  { label: 'Leases', tab: 'leases', target: '/finance?tab=leases', icon: 'assets/svg/document-text-outline.svg' },
  { label: 'Transactions', tab: 'transactions', target: '/finance?tab=transactions', icon: 'assets/svg/swap-horizontal-outline.svg' },
  { label: 'Taxes', tab: 'taxes', target: '/finance?tab=taxes', icon: 'assets/svg/calculator-outline.svg' },
  { label: 'Monthly P&L', tab: 'monthly', target: '/finance?tab=monthly', icon: 'assets/svg/bar-chart-outline.svg' },
];

export const marketingSection = {
  label: 'Revenue',
  // The Revenue section header only expands/collapses in the desktop nav.
  // Listings is the first sub-item, so it's the conceptual landing tab.
  target: '/listings',
};

export const marketingSectionItems = [
  { label: 'Listings', tab: 'listings', isOverview: true, route: '/listings', target: '/listings', icon: 'assets/svg/swap-horizontal-outline.svg' },
  { label: 'Leasing', tab: 'leasing', target: '/revenue?tab=leasing', icon: 'assets/svg/document-text-outline.svg' },
  { label: 'Optimizer', tab: 'optimizer', isOverview: true, route: '/optimizer', target: '/optimizer', icon: 'assets/svg/options-outline.svg' },
  { label: 'Upsells', tab: 'upsells', target: '/revenue?tab=upsells', icon: 'assets/svg/trending-up-outline.svg' },
  { label: 'Upgrades', tab: 'upgrades', isOverview: true, route: '/upgrades', target: '/upgrades', icon: 'assets/svg/rocket-outline.svg' },
  { label: 'Reviews', tab: 'reviews', target: '/revenue?tab=reviews', icon: 'assets/svg/star-outline.svg' },
  { label: 'Inquiries', tab: 'inquiries', isOverview: true, route: '/inquiries', target: '/inquiries', icon: 'assets/svg/calendar-outline.svg' },
  { label: 'Direct Booking', tab: 'direct-booking', isOverview: true, route: '/direct-booking', target: '/direct-booking', icon: 'assets/svg/globe-outline.svg' },
  { label: 'Wi-Fi Marketing', tab: 'wifi', target: '/revenue?tab=wifi', icon: 'assets/svg/wifi-outline.svg' },
  { label: 'Happiness', tab: 'happiness', target: '/revenue?tab=happiness', icon: 'assets/svg/happy-outline.svg' },
];

export const complianceItem = {
  icon: 'assets/svg/shield-checkmark-outline.svg',
  activeIcon: 'assets/img/shield-green.svg',
  label: 'Compliance',
  target: '/compliance',
  showAgentIndicator: true,
  key: 'compliance_agent'
};

export const guidebookItem = {
  icon: 'assets/svg/map-outline.svg',
  activeIcon: 'assets/img/menu-guidebook-green.svg',
  label: 'Guidebook',
  target: '/guidebook',
  showAgentIndicator: false,
};

export const eSignItem = {
  icon: 'assets/svg/document-text-outline.svg',
  activeIcon: 'assets/svg/document-text-outline.svg',
  label: 'eSignature',
  target: '/e-sign',
  showAgentIndicator: false,
};

export const moreAccountingItem = {
  activeIcon: 'assets/img/integration-images/accounting-integration-green.svg',
  icon: 'assets/img/integration-images/accounting-integration-white.svg',
  label: 'Accounting',
  target: '/integration/accounting',
};

export const auditLogsItem = {
  icon: 'assets/img/history-outline-white.svg',
  activeIcon: 'assets/img/history-outline-green.svg',
  label: 'Audit Logs',
  target: '/audit-logs',
}

export const teamsItem = {
  icon: 'assets/svg/people-outline-white.svg',
  activeIcon: 'assets/svg/people-green.svg',
  label: 'Groups',
  target: '/groups'
}

export const dashboardReportItem = {
  target: 'overview/report'
};

export const employerItemsMock = [
  {
    icon: 'assets/img/play-white.svg',
    activeIcon: 'assets/img/play-green.svg',
    label: 'Get Started',
    target: '/employer-get-started',
  },
  {
    icon: 'assets/img/integrate-white.svg',
    activeIcon: 'assets/img/integrate-green.svg',
    label: 'Integrations',
    target: '/employer-integrations',
  },
  {
    icon: 'assets/img/people-white.svg',
    activeIcon: 'assets/img/people-green.svg',
    label: 'Employees',
    target: '/employer-employees',
  },
  {
    icon: 'assets/img/campaign-white.svg',
    activeIcon: 'assets/img/campaign-green.svg',
    label: 'Campaigns',
    target: '/employer-campaign',
  },
  {
    icon: 'assets/img/shield-white.svg',
    activeIcon: 'assets/img/shield-green.svg',
    label: 'Compliance',
    target: '/employer-compliance',
  },
];

export const employerItems = [
  {
    icon: 'assets/img/menu-dashboard-white.svg',
    activeIcon: 'assets/img/menu-dashboard-green.svg',
    label: 'Dashboard',
    target: '/employer-dashboard/employer-dashboard',
    showAgentIndicator: false
  },
  {
    icon: 'assets/img/menu-bills-white.svg',
    activeIcon: 'assets/img/menu-bills-green.svg',
    label: 'Campaigns',
    target: '/employer-campaign/employer-campaign',
    showAgentIndicator: false
  },
  {
    icon: 'assets/img/menu-my-pros-white.svg',
    activeIcon: 'assets/img/menu-my-pros-green.svg',
    label: 'Admins',
    target: '/employer-admins/employer-admins',
    showAgentIndicator: false
  },
  {
    icon: 'assets/img/settings-white.svg',
    activeIcon: 'assets/img/settings-green.svg',
    label: 'Settings',
    target: '/employer-settings',
    showAgentIndicator: false
  },
];
